import { TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4 } from '../config';

const RegisterRoutes = [
  { container: 'auth/login' },
  { container: 'auth/verify' },
];

// 'container' => the route
// 'templates' => accessible for which templates (empty array means accessible for all templates)
const PrivateRoutes = [
  {
    container: '',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  { container: 'products', templates: [TEMPLATE_1, TEMPLATE_2] },
  { container: 'restaurant', templates: [TEMPLATE_3] },
  {
    container: 'create-business',
    templates: [],
  },
  { container: 'settings', templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4] },
  {
    container: 'settings/business-validation',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'settings/profile',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'settings/ipg',
    templates: [TEMPLATE_1, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'invoice/create',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'invoice/quick-create',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'invoice/list',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'requests/what-do-you-need',
    templates: [TEMPLATE_1, TEMPLATE_4],
  },
  {
    container: 'requests/direct-requests',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/banners',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/logo',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/colors',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/sliders',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/sliders/:sliderId',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/tiles',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/graphical/tiles/:tileId',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/about-us',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/footer',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/seo',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/terms',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/enamad',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/samandehi',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  {
    container: 'personal-site/settings/textual/faq',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4],
  },
  { container: 'personal-site/mega-menu', templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4] },
  { container: 'personal-site/search', templates: [TEMPLATE_2] },
  { container: 'customers', templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_3] },
  {
    container: 'personal-site/tagsAndCategory',
    templates: [TEMPLATE_1,TEMPLATE_2, TEMPLATE_3, TEMPLATE_4 ],
  },
  {
    container: 'personal-site/tagsAndCategory/Tags',
    templates: [TEMPLATE_1,TEMPLATE_2, TEMPLATE_3, TEMPLATE_4 ],
  },
  {
    container: 'personal-site/tagsAndCategory/Tags',
    templates: [TEMPLATE_1,TEMPLATE_2, TEMPLATE_3, TEMPLATE_4 ],
  },
  {
    container: 'personal-site/blog',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/blog/posts',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/blog/comments',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/blog/posts/:postId',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/blog/settings',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/blog/settings/services',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/blog/settings/authors',
    templates: [TEMPLATE_2],
  },
  {
    container: 'personal-site/application',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4],
  },
  {
    container: 'personal-site/application/graphical/banners',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4],
  },
  {
    container: 'personal-site/application/graphical/sliders',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4],
  },
  {
    container: 'personal-site/application/graphical/sliders/:sliderId',
    templates: [TEMPLATE_1, TEMPLATE_2, TEMPLATE_4],
  },
];

const routes = {
  RegisterRoutes,
  PrivateRoutes,
};

export default routes;
